import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import TrainerMember from "../TrainerMember";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import DashboardCard from "../../../pages/home/common/DashboardCard";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";

const GTPTreports = ({ stats, prevAllFilters }) => {
  const { trainerReportsStatsLoading } = useSelector((state) => state.api);

  const initialClickValues = {
    isModOpen: false,
    cardName: "",
    cardValue: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onClickCard = (cardName, cardValue) => {
    setClickValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardName: cardName,
      cardValue: cardValue,
    }));
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Trainer Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer minWidth80vw">
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/_/g, " ")} - ${
              clickValues.cardValue
            }`}
            onClose={onCloseModal}
          />

          <TrainerMember
            cardName={clickValues.cardName}
            prevAllFilters={prevAllFilters}
            isGTPTreports={true}
          />
        </div>
      </Modal>

      {trainerReportsStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-container cards-grid-container grid-3 mt-2rem">
          <DashboardCard
            tagName={"members"}
            cardLabel={"total trainer"}
            value={stats?.total_trainer || 0}
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"total personal trainer"}
            value={stats?.total_personal_trainer || 0}
            onClickCard={onClickCard}
          />

          <DashboardCard
            tagName={"members"}
            cardLabel={"total general trainer"}
            value={stats?.total_general_trainer || 0}
            onClickCard={onClickCard}
          />
        </div>
      )}
    </>
  );
};

export default GTPTreports;
